import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getBusinessProcessBaseExecutors: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTORS,
	},
	getBusinessProcessBaseExecutorPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_POPUP,
	},
	getBusinessProcessBaseExecutorPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_PREVIEW,
	},
	getBusinessProcessBaseExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR,
	},
	createBusinessProcessBaseExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].CREATE_BUSINESS_PROCESS_BASE_EXECUTOR,
	},
	patchBusinessProcessBaseExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PATCH_BUSINESS_PROCESS_BASE_EXECUTOR,
	},
	putBusinessProcessBaseExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PUT_BUSINESS_PROCESS_BASE_EXECUTOR,
	},
	deleteBusinessProcessBaseExecutor: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].DELETE_BUSINESS_PROCESS_BASE_EXECUTOR,
	},
}
